import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import moment from 'moment'
import {toast} from 'react-toastify'
import {Tag} from '../../../../../services/cellcast.v3.types'
import './TagMobileCard.scss'

interface TagMobileAction {
  key: string
  label: string
  icon?: string
  danger?: boolean
  onClick: () => void
}

interface TagMobileCardProps {
  tag: Tag & {contactCount?: number}
  isDefaultRegion?: boolean
  onEdit: (tag: Tag) => void
  onDelete: (id: string) => void
  onExport: (id: string) => void
  onViewContacts: (tagId: string) => void
}

export const TagMobileCard: React.FC<TagMobileCardProps> = ({
  tag,
  isDefaultRegion = false,
  onEdit,
  onDelete,
  onExport,
  onViewContacts,
}) => {
  const [showActions, setShowActions] = useState(false)
  const navigate = useNavigate()

  const handleActionClick = () => {
    setShowActions(!showActions)
  }

  const actions: TagMobileAction[] = []

  if (AuthenticateUser('send-quick-sms') && isDefaultRegion) {
    actions.push({
      key: 'run-campaign',
      label: 'Run campaign',
      icon: 'bi bi-send',
      onClick: () => {
        navigate(`/new-message`, {
          state: {
            selectedType: 'segmentOrTags',
            data: `tag_${tag._id}`,
          },
        })
        setShowActions(false)
      },
    })
  }

  if (AuthenticateUser('tags-list')) {
    actions.push({
      key: 'view-contacts',
      label: 'View contacts',
      icon: 'bi bi-eye',
      onClick: () => {
        onViewContacts(tag._id)
        setShowActions(false)
      },
    })
  }

  if (AuthenticateUser('export-tagged-contacts') && isDefaultRegion) {
    actions.push({
      key: 'export',
      label: 'Export as CSV',
      icon: 'bi bi-download',
      onClick: () => {
        onExport(tag._id)
        setShowActions(false)
      },
    })
  }

  actions.push({
    key: 'copy-id',
    label: 'Copy ID',
    icon: 'bi bi-clipboard',
    onClick: () => {
      navigator.clipboard.writeText(tag._id)
      toast.success('Successfully copied tag id')
      setShowActions(false)
    },
  })

  if (AuthenticateUser('edit-tag')) {
    actions.push({
      key: 'edit',
      label: 'Edit',
      icon: 'bi bi-pencil',
      onClick: () => {
        onEdit(tag)
        setShowActions(false)
      },
    })
  }

  if (AuthenticateUser('delete-tag')) {
    actions.push({
      key: 'delete',
      label: 'Delete',
      icon: 'bi bi-trash',
      danger: true,
      onClick: () => {
        onDelete(tag._id)
        setShowActions(false)
      },
    })
  }

  return (
    <div className='tag-mobile-card'>
      {/* Header with tag name and actions */}
      <div className='card-header-section'>
        <div className='tag-info-section'>
          <div
            className='tag-name-badge cursor-pointer'
            onClick={() => onViewContacts(tag._id)}
            style={{
              color: tag?.color ? 'white' : 'black',
              backgroundColor: tag?.color ? tag.color : '',
            }}
          >
            {tag?.name}
          </div>
        </div>
        <button
          className='btn btn-action-mobile'
          onClick={handleActionClick}
          aria-label='Actions menu'
          aria-expanded={showActions}
        >
          <i className='bi bi-three-dots-vertical'></i>
        </button>
      </div>

      {/* Actions dropdown */}
      {showActions && (
        <div className='actions-dropdown'>
          {actions.map((action) => (
            <button
              key={action.key}
              className={`action-item ${action.danger ? 'text-danger' : ''}`}
              onClick={action.onClick}
            >
              {action.icon && <i className={`${action.icon} me-2`}></i>}
              {action.label}
            </button>
          ))}
        </div>
      )}

      {/* Tag details grid */}
      <div className='card-details-grid'>
        {/* Contacts Count */}
        <div className='detail-item full-width'>
          <span className='detail-label'>
            <i className='bi bi-people me-1'></i>
            Contacts
          </span>
          <span className='detail-value'>
            {tag?.contactCount !== undefined && tag?.contactCount !== null
              ? tag.contactCount
              : '..counting'}
          </span>
        </div>

        {/* Date Created */}
        {tag?.createdAt && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-calendar-plus me-1'></i>
              Date Created
            </span>
            <span className='detail-value'>{moment(tag.createdAt).format('DD/MM/YYYY hh:mm A')}</span>
          </div>
        )}

        {/* Time Created */}
        {tag?.updatedAt && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-clock me-1'></i>
              Updated Time
            </span>
            <span className='detail-value'>{moment(tag.updatedAt).format('DD/MM/YYYY hh:mm A')}</span>
          </div>
        )}

      </div>

      {/* Action buttons */}
      <div className='card-actions'>
        {AuthenticateUser('edit-tag') && (
          <button className='btn btn-light btn-sm' onClick={() => onEdit(tag)}>
            <i className='bi bi-pencil me-2'></i>
            Edit
          </button>
        )}
        <button
          className='btn btn-light btn-sm'
          onClick={() => onViewContacts(tag._id)}
        >
          <i className='bi bi-eye me-2'></i>
          View
        </button>
        {AuthenticateUser('send-quick-sms') && isDefaultRegion && (
          <button
            className='btn btn-light-primary btn-sm'
            onClick={() => {
              navigate(`/new-message`, {
                state: {
                  selectedType: 'segmentOrTags',
                  data: `tag_${tag._id}`,
                },
              })
            }}
          >
            <i className='bi bi-send me-2'></i>
            Campaign
          </button>
        )}
      </div>
    </div>
  )
}

